const initState = {

    loading: null,
    errore: null,
    reports: null,
};

const reportReducer = (state = initState, action) => {



    switch (action.type) {


        case 'GET_REPORTS_SUCCESS':
            return {
        ...state,
        loading: false,
        reports: action.report,
        error: null,
        };


        case 'GET_REPORTS_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.error,
            };

         case 'GET_REPORT_SUCCESS':
            return {
                ...state,
                loading: false,
                currentReport:  action.payload, // optionally set the first one as current
                error: null,
            };

            
        case 'CREATE_REPORT_SUCCESS':
            const newReport = action.report; 
            return {
                ...state,
                loading: false,
                //reports: [newReport, ...(state.reports || [])], // ensure state.reports is not null
                currentReport: newReport,
                error: null,
            };

        case "REPORT_DELETED":
            return {
                ...state,
                reports: state.reports.filter(report => report.id !== action.payload),
            }

        case 'CLEAR_CURRENT_REPORT':
            return {
                ...state,
                currentReport: null,
  };
        

        default:
            return state;
    }
};

export default reportReducer;
